import React from 'react'
import { Row, Col} from 'antd'



import BucketCostChart from './bucket-cost-chart'
import BucketCostFilter from './bucket-cost-filter'
import UsageTypeChart from './usage-type-chart'
import OperationChart from './operation-chart'
import './bucket-cost.scss'



export default ({ bucketCostData, on_bucket_change, on_bucket_usage_type_change, on_clear_filter_bucket_cost }) => {

    let dataBucket = new window.google.visualization.DataTable()
    let formatter = new window.google.visualization.NumberFormat({
      pattern: '$#.##',
      fractionDigits: 2
    })

    dataBucket.addColumn('string', 'Topping')
    dataBucket.addColumn('number', 'Slices')
    
    if (bucketCostData && bucketCostData.bucketChartData && (bucketCostData.bucketChartData.length > 0))
    {
        dataBucket.addRows(bucketCostData.bucketChartData)
        formatter.format(dataBucket, 1)
    }      



    let dataUsage = new window.google.visualization.DataTable()
    let formatterUsage = new window.google.visualization.NumberFormat({
      pattern: '$#.####',
      fractionDigits: 2
    })

    dataUsage.addColumn('string', 'Topping')
    dataUsage.addColumn('number', 'Slices')
    
    if (bucketCostData && bucketCostData.usageTypeChartData && (bucketCostData.usageTypeChartData.length > 0))
    {
        dataUsage.addRows(bucketCostData.usageTypeChartData)
        formatterUsage.format(dataUsage, 1)
    }      

    
    let dataOperation = new window.google.visualization.DataTable()
    let formatterOperation = new window.google.visualization.NumberFormat({
      pattern: '$#.####',
      fractionDigits: 2
    })

    dataOperation.addColumn('string', 'Topping')
    dataOperation.addColumn('number', 'Slices')
    
    if (bucketCostData && bucketCostData.operationChartData && (bucketCostData.operationChartData.length > 0))
    {
        dataOperation.addRows(bucketCostData.operationChartData)
        formatterOperation.format(dataOperation, 1)
    }      



    let bucketChartSize = 12
    let usageTypeChartSize = 6
    let operationChartSize = 6
    let bucketIndex = 0
    let usageTypeIndex = 0
    let bucketSlices =  {}
    let usageTypeSlices =  {}

    if(bucketCostData.selectedBucket)
    {
        bucketChartSize = 6
        usageTypeChartSize = 12
        operationChartSize = 6
        bucketIndex = bucketCostData.bucketCosts.findIndex(y => y.bucket_name == bucketCostData.selectedBucket.bucket_name)
        bucketSlices[bucketIndex] =  {offset: 0.2}

        if(bucketCostData.selectedUsageType){
            bucketChartSize = 6
            usageTypeChartSize = 6
            operationChartSize = 12
            usageTypeIndex = bucketCostData.selectedBucket.usage_types.findIndex(y => y.usage_type == bucketCostData.selectedUsageType.usage_type)
            usageTypeSlices[usageTypeIndex] =  {offset: 0.2}            
        }
    }


    return (
    <div>
        <Row type="flex" gutter={30} className="overview-container">
        <Col span={4}>
                <Row type="flex" className="rowStyle">
                    <BucketCostFilter bucketCostData={bucketCostData} on_bucket_change={on_bucket_change} on_bucket_usage_type_change={on_bucket_usage_type_change} on_clear_filter_bucket_cost={on_clear_filter_bucket_cost} />
                </Row>
            </Col>

            <Col span={20}>
                <Row className="rowStyle">
                    <div className="overview-chart-container">
                        <Col span={24}>
                            <Row gutter={20}>
                                <Col span={bucketChartSize}>
                                    <BucketCostChart bucketSlices={bucketSlices} bucketListChart={dataBucket} /> 
                                </Col>
                                <Col span={usageTypeChartSize}>
                                    <UsageTypeChart usageTypeSlices={usageTypeSlices} selectedBucket={bucketCostData.selectedBucket} usageTypeChartData={dataUsage} />
                                </Col>
                                <Col span={operationChartSize}>
                                    <OperationChart selectedUsageType={bucketCostData.selectedUsageType} operationChartData={dataOperation} />
                                </Col>
                            </Row>
                        </Col>
                    </div>
                </Row>
            </Col>
        </Row>
    </div>
)
} 